<template>
  <div>
    <b-table-simple caption-top responsive bordered>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="text-center">STT</b-th>
          <b-th class="text-center">Product Key</b-th>
          <b-th class="text-center">Permission Keys</b-th>
          <b-th class="text-center">Action</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item, index) in products">
          <b-tr :key="item._id || index">
            <b-th class="text-center">{{ index + 1 }}</b-th>
            <b-th class="text-center">{{ item.product_key }}</b-th>
            <b-th v-if="item.permission_keys.length" class="text-center">
              <template v-for="key in item.permission_keys">
                <div :key="key">{{ key }}</div>
              </template>
            </b-th>
            <b-th v-else/>
            <b-th class="text-center">
              <b-button
                variant="gradient-warning"
                style="margin-right: 5px"
                class="btn-icon"
                @click="editProduct(item._id)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                @click="confirmDelete(item._id)"
                variant="gradient-danger"
                class="btn-icon"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </b-th>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import service from "../../service";

export default {
  props: {
    products: { type: Array, required: true },
  },

  methods: {
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure ?", {
          title: "Please Confirm",
          size: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.deleteProduct(id);
          }
        });
    },

    async deleteProduct(id) {
      await service.delete({ id: id });
      this.$emit("getList");
    },

    editProduct(id) {
      this.$emit('edit', id)
    },
  },
};
</script>
